import { Component, Input, OnChanges, OnInit, SimpleChanges, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { countryList, RegistraionTypes } from '../../../../utils/constants/utility';

@Component({
  selector: 'app-importer-taxsetting',
  templateUrl: './taxsetting.component.html',
  styleUrls: ['./taxsetting.component.scss'],
})
export class ImporterTaxSettingComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() configurationImporter = [];
  importerRegistraionTypes;
  importerTaxSetting: FormGroup;
  ImporterDataSource = new MatTableDataSource<any>();
  ImporterData: any;
  isValueChanged: boolean = false;
  list = [];

  columns: string[] = [
    'number',
    'importerRegistrationType',
    'importerRegistrationNumber',
    'importerIssuingCountryCode',
    'Action',
  ];
  constructor(
    private fb: FormBuilder,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService
  ) {}

  ngOnInit(): void {
    this.importerTaxSetting = this.fb.group({
      _id: '',
      config_id: '',
      customer_id: '',
      updated_by_username: '',
      updated_time: '',
      data: this.fb.array([]),
    });
    this.importerRegistraionTypes = RegistraionTypes;
    this.list = countryList;
  }

  AddNewImporterItem() {
    const control = this.importerTaxSetting.get('data') as FormArray;
    control.insert(
      (this.importerTaxSetting.get('data') as FormArray).controls.length + 1,
      this.addImporterGroup()
    );
    this.ImporterDataSource = new MatTableDataSource(control.controls);
  }

  DeleteImporterItem(_formElement, i) {
    const control = this.importerTaxSetting.get('data') as FormArray;
    control.removeAt(i);
    this.ImporterDataSource = new MatTableDataSource(
      (this.importerTaxSetting.get('data') as FormArray).controls
    );
  }

  private addImporterGroup(): FormGroup {
    return this.fb.group({
      importerRegistrationType: new FormControl('', Validators.compose([Validators.required])),
      importerRegistrationNumber: new FormControl('', Validators.compose([Validators.required])),
      importerIssuingCountryCode: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  getImporterFormControlId(id, control) {
    return (this.importerTaxSetting.get('data') as FormArray).controls[id].get(control);
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'configurationImporter':
            this.getImporterTypes(this.configurationImporter);
            break;
        }
      }
    }
  }

  getImporterTypes(formData) {
    if (formData) {
      this.importerTaxSetting.patchValue(formData);
      this.ImporterData = formData;
      const ImporterArray = formData;
      (this.importerTaxSetting.get('data') as FormArray).clear();
      ImporterArray.forEach(item => {
        const ImporterGrp = this.addImporterGroup();
        ImporterGrp.patchValue(item);
        (this.importerTaxSetting.get('data') as FormArray).push(ImporterGrp);
      });
      this.ImporterDataSource = new MatTableDataSource(
        (this.importerTaxSetting.get('data') as FormArray).controls
      );
    }
  }

  saveImporterConfig() {
    const config = this.importerTaxSetting.value;
    config.config_id = 'importer_tax_setting';
    this.configService.saveConfig(config).subscribe(() => {
      this.errorDialogService.openDialog('alert.configurationSuccess', false);
      this.isValueChanged = false;
      this.configService.putConfig(config.config_id, config.data);
    });
  }

  ngAfterViewInit() {
    this.isAnyValueUnChanged();
  }

  isAnyValueUnChanged() {
    setTimeout(() => {
      setTimeout(
        function () {
          this.importerTaxSetting.valueChanges.subscribe(() => {
            this.isValueChanged = true;
          });
        }.bind(this),
        0
      );
    }, 1000);
  }
}
